<template>
  <el-form-item :label="islable?formData.name:''"
                :prop="itemkey!==undefined?tablemodel + '.' + itemkey + '.' + formData.model : formData.model"
                :rules="rules[formData.model]" :label-width="islable?'':'0'" :class="formData.options.otherClass">
    <template v-if="formData.type == 'input'">
      <el-input
        v-if="formData.options.dataType == 'number' || formData.options.dataType == 'integer' || formData.options.dataType == 'float'"
        :type="formData.options.dataType"
        v-model.number="dataModel"
        :placeholder="formData.options.placeholder"
        :style="{width: formData.options.width}"
        :disabled="disableItem"
        @input="checkFunction(formData.options.remoteFunc,$event)"
      ></el-input>
      <el-input
        v-else
        :type="formData.options.dataType"
        v-model="dataModel"
        :disabled="disableItem"
        :placeholder="formData.options.placeholder"
        :style="{width: formData.options.width}"
        @input="checkFunction(formData.options.remoteFunc,$event)"
      ></el-input>
    </template>

    <template v-if="formData.type == 'textarea'">
      <el-input type="textarea" :rows="5"
                v-model="dataModel"
                :disabled="disableItem"
                :placeholder="formData.options.placeholder"
                :style="{width: formData.options.width}"
                @input="checkFunction(formData.options.remoteFunc,$event)"
      ></el-input>
    </template>

    <template v-if="formData.type == 'number'">
      <el-input-number
        v-model="dataModel"
        :style="{width: formData.options.width}"
        :step="formData.options.step"
        :min="formData.options.min > 0||formData.options.min===0 ? formData.options.min : -Infinity"
        :max="formData.options.max > 0 ? formData.options.max : Infinity"
        :controls-position="formData.options.controlsPosition"
        :disabled="disableItem"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      ></el-input-number>
    </template>

    <template v-if="formData.type == 'radio'">
      <el-radio-group v-model="dataModel" @change="checkFunction(formData.options.remoteFunc,$event)"
                      :style="{width: formData.options.width}"
                      :disabled="disableItem"
      >
        <el-radio
          :style="{display: formData.options.inline ? 'inline-block' : 'block'}"
          :label="item.value"
          v-for="(item, index) in (formData.options.remote ? formData.options.remoteOptions : formData.options.options)"
          :key="index"
        >
          <template v-if="formData.options.remote">{{ item.label }}</template>
          <template v-else>{{ formData.options.showLabel ? item.label : item.value }}</template>
        </el-radio>
      </el-radio-group>
    </template>

    <template v-if="formData.type == 'checkbox'">
      <el-checkbox-group v-model="dataModel" @change="checkFunction(formData.options.remoteFunc,$event)"
                         :style="{width: formData.options.width}"
                         :disabled="disableItem"
      >
        <el-checkbox
          :style="{display: formData.options.inline ? 'inline-block' : 'block'}"
          :label="item.value"
          v-for="(item, index) in (formData.options.remote ? formData.options.remoteOptions : formData.options.options)"
          :key="index"
        >
          <template v-if="formData.options.remote">{{ item.label }}</template>
          <template v-else>{{ formData.options.showLabel ? item.label : item.value }}</template>
        </el-checkbox>
      </el-checkbox-group>
    </template>

    <template v-if="formData.type == 'time'">
      <el-time-picker
        v-model="dataModel"
        :is-range="formData.options.isRange"
        :placeholder="formData.options.placeholder"
        :start-placeholder="formData.options.startPlaceholder"
        :end-placeholder="formData.options.endPlaceholder"
        :readonly="formData.options.readonly"
        :disabled="disableItem"
        :editable="formData.options.editable"
        :clearable="formData.options.clearable"
        :arrowControl="formData.options.arrowControl"
        :value-format="formData.options.format"
        :style="{width: formData.options.width}"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </el-time-picker>
    </template>

    <template v-if="formData.type=='date'">
      <el-date-picker
        v-model="dataModel"
        :type="formData.options.type"
        :placeholder="formData.options.placeholder"
        :start-placeholder="formData.options.startPlaceholder"
        :end-placeholder="formData.options.endPlaceholder"
        :readonly="formData.options.readonly"
        :disabled="disableItem"
        :editable="formData.options.editable"
        :clearable="formData.options.clearable"
        :value-format="formData.options.timestamp ? 'timestamp' : formData.options.format"
        :format="formData.options.format"
        :style="{width: formData.options.width}"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </el-date-picker>
    </template>

    <template v-if="formData.type =='rate'">
      <el-rate v-model="dataModel"
               :max="formData.options.max"
               :disabled="disableItem"
               :allow-half="formData.options.allowHalf"
               @change="checkFunction(formData.options.remoteFunc,$event)"
      ></el-rate>
    </template>

    <template v-if="formData.type == 'color'">
      <el-color-picker
        v-model="dataModel"
        :disabled="disableItem"
        :show-alpha="formData.options.showAlpha"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      ></el-color-picker>
    </template>

    <template v-if="formData.type == 'select'">
      <el-select
        v-model="dataModel"
        :disabled="disableItem"
        :multiple="formData.options.multiple"
        :clearable="formData.options.clearable"
        :placeholder="formData.options.placeholder"
        :style="{width: formData.options.width}"
        :filterable="formData.options.filterable"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
        <el-option v-for="item in (formData.options.remote ? formData.options.remoteOptions : formData.options.options)"
                   :key="item.value" :value="item.value"
                   :label="formData.options.showLabel || formData.options.remote?item.label:item.value"></el-option>
      </el-select>
    </template>

    <template v-if="formData.type=='switch'">
      <el-switch v-if="(formData.options.customizeopen+'').length > 0&&(formData.options.customizeclose+'').length > 0"
                 v-model="dataModel"
                 @change="checkFunction(formData.options.remoteFunc,$event)"
                 :disabled="disableItem"
                 :active-value="formData.options.customizeopen" :inactive-value="formData.options.customizeclose"
      ></el-switch>
      <el-switch v-else
                 v-model="dataModel"
                 @change="checkFunction(formData.options.remoteFunc,$event)"
                 :disabled="disableItem"
      >
      </el-switch>
    </template>

    <template v-if="formData.type=='slider'">
      <el-slider
        v-model="dataModel"
        :min="formData.options.min"
        :max="formData.options.max"
        :disabled="disableItem"
        :step="formData.options.step"
        :show-input="formData.options.showInput"
        :range="formData.options.range"
        :style="{width: formData.options.width}"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      ></el-slider>
    </template>

    <template v-if="formData.type === 'imgupload'">
      <Upload
        v-model="dataModel"
        :disabled="disableItem"
        :style="{'width': formData.options.width}"
        :width="formData.options.size.width"
        :height="formData.options.size.height"
        :token="formData.options.token"
        :domain="formData.options.domain"
        :multiple="formData.options.multiple"
        :length="formData.options.length"
        :is-qiniu="formData.options.isQiniu"
        :is-delete="formData.options.isDelete"
        :min="formData.options.min"
        :is-edit="formData.options.isEdit"
        :action="formData.options.action"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </Upload>
    </template>

    <template v-if="formData.type === 'formimgupload'">
      <FormUpload
        v-model="dataModel"
        :disabled="disableItem"
        :style="{'width': formData.options.width}"
        :width="formData.options.size.width"
        :height="formData.options.size.height"
        :token="formData.options.token"
        :domain="formData.options.domain"
        :multiple="formData.options.multiple"
        :length="formData.options.length"
        :is-qiniu="formData.options.isQiniu"
        :is-delete="formData.options.isDelete"
        :min="formData.options.min"
        :is-edit="formData.options.isEdit"
        :action="formData.options.action"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </FormUpload>
    </template>

    <template v-if="formData.type == 'editor'">
      <vue-editor
        v-model="dataModel"
        :style="{width: formData.options.width}"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </vue-editor>
    </template>

    <template v-if="formData.type == 'cascader'">
      <el-cascader
        v-model="dataModel"
        :disabled="disableItem"
        :clearable="formData.options.clearable"
        :placeholder="formData.options.placeholder"
        :style="{width: formData.options.width}"
        :options="formData.options.remoteOptions"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </el-cascader>
    </template>

    <template v-if="formData.type == 'text'">
      <span>{{ dataModel }}</span>
    </template>

    <template v-if="formData.type == 'selecType'">
      <select-type ref="selectType"
                   :isEdit="formData.options.isEdit"
                   :typeId="formData.options.typeId"
                   v-model="dataModel"
                   :disabled="disableItem"
                   :multiple="formData.options.multiple"
                   :clearable="formData.options.clearable"
                   :placeholder="formData.options.placeholder"
                   :style="{width: formData.options.width}"
                   @change="checkFunction(formData.options.remoteFunc,$event)"
                   :filterable="formData.options.filterable"/>
    </template>

    <template v-if="formData.type == 'selecTypeByApi'">
      <select-type-by-api
        :disabled="disableItem"
        :id.sync="dataModel"
        :name.sync="models[formData.options.relatedName]"
        :idKey="formData.options.idKey"
        :nameKey="formData.options.nameKey"
        :apiName="formData.options.apiName"
        :getDataMethod="formData.options.getDataMethod"
        :otherQuery="otherQuery"
        :multiple="formData.options.multiple"
        :style="{width: formData.options.width}"
        @change="checkFunction(formData.options.remoteFunc,$event)"
      >
      </select-type-by-api>
    </template>

    <template v-if="formData.type == 'autoNew'">
      <auto-new ref="autoNew"
                :disabled="disableItem"
                :id.sync="dataModel"
                :name.sync="models[formData.options.relatedName]"
                :idKey="formData.options.idKey"
                :nameKey="formData.options.nameKey"
                :apiName="formData.options.apiName"
                :getDataMethod="formData.options.getDataMethod"
                :otherQuery="otherQuery"
                :returnKey="formData.options.returnKey"
                :style="{width: formData.options.width}"
                @postdata="(val)=>{
         Object.keys(val).forEach(item=>{
           models[item]=val[item]
         })
         }"
                @change="checkFunction(formData.options.remoteFunc,$event)"
      ></auto-new>
    </template>
  </el-form-item>
</template>

<script>
import Upload from './ImageUpload';
import FormUpload from './FormImageUpload';
import SelectType from '@/components/SelectType';
import SelectTypeByApi from '@/components/SelectTypeByApi';
import autoNew from '@/components/AutoNew';

export default {
  props: ['formData', 'models', 'rules', 'remote', 'islable', 'funModel', 'itemkey', 'tablemodel', 'disableArr'],
  components: {
    Upload, SelectType, autoNew, FormUpload, SelectTypeByApi
  },
  data() {
    return {
      dataModel: this.models[this.formData.model], // 当前控件所用数据
      otherQuery: []// 查询条件，仅关联选择组件使用
    };
  },
  created() {
    if (this.formData.type === 'date') { // 初始化日期
      if (this.models[this.formData.model] === null || this.models[this.formData.model] === '') {
        this.models[this.formData.model] = new Date();
      }
    }
    if (this.formData.type === 'switch') {
      const tempcustomizeopen = this.formData.options.customizeopen + '';
      const tempcustomizeclose = this.formData.options.customizeclose + '';
      switch (this.formData.options.customizeType) {
        case 'string':
          this.formData.options.customizeopen = tempcustomizeopen;
          this.formData.options.customizeclose = tempcustomizeclose;
          break;
        case 'boolean':
          this.formData.options.customizeopen = tempcustomizeopen.toLocaleLowerCase() === 'true';
          this.formData.options.customizeclose = tempcustomizeclose.toLocaleLowerCase() === 'true';
          break;
        case 'integer':
          this.formData.options.customizeopen = parseInt(tempcustomizeopen);
          this.formData.options.customizeclose = parseInt(tempcustomizeclose);
          break;
        default:
          break;
      }
    }

    // console.log('prop===' + this.tablemodel + '.' + this.itemkey + '.' + this.formData.model)
    if (this.formData.options.remote && this.remote[this.formData.options.remoteFunc]) {
      this.remote[this.formData.options.remoteFunc]((data) => {
        this.formData.options.remoteOptions = data.map(item => {
          return {
            value: item[this.formData.options.props.value],
            label: item[this.formData.options.props.label],
            children: item[this.formData.options.props.children]
          };
        });
      });
    }
    if (this.formData.type === 'imgupload' && this.formData.options.isQiniu) {
      this.remote[this.formData.options.tokenFunc]((data) => {
        this.formData.options.token = data;
      });
    }
    if (this.formData.type === 'autoNew' && this.formData.options.otherquery && this.formData.options.otherquery.length > 0) {
      this.formData.options.otherquery.forEach(item => { // 添加或修改查询条件
        const otherIndex = this.otherQuery.findIndex(m => { // 查找有没有对应的查询条件
          return m.key === item.querykey;
        });
        if (otherIndex > -1) { // 若有，则修改
          this.otherQuery[otherIndex].value = this.models[item.modelkey] === undefined ? item.modelkey : this.models[item.modelkey];// 如果为空则为值，不是对象中的属性字段的值
          this.otherQuery[otherIndex].relation = item.relation ? item.relation : '==';// 关系符
        } else {
          this.otherQuery.push({
            key: item.querykey, // 查询的key
            relation: item.relation ? item.relation : '=', // 关系符
            value: this.models[item.modelkey] === undefined ? item.modelkey : this.models[item.modelkey]// 如果为空则为值，不是对象中的属性字段的值
          });
        }
      });
    }
  },
  methods: {
    checkFunction(fn, val) {
      if (this.funModel && Object.keys(this.funModel).indexOf(fn) >= 0 && typeof (this.funModel[fn]) === 'function') {
        this.funModel[fn](val, this.models, this.formData.model);
      }
      const Tempobj = { modelkey: this.formData.model, val, models: this.models };
      this.$emit('changeData', Tempobj);
    }
  },
  computed: {
    disableItem() {
      if (this.disableArr && this.disableArr.length > 0) {
        return this.disableArr.includes(this.formData.model) ? true : this.formData.options.disabled;
      } else {
        return this.formData.options.disabled;
      }
    }
  },
  watch: {
    dataModel: {
      deep: true,
      handler(val) {
        this.$set(this.models, this.formData.model, val);
        // this.models[] =
        this.$emit('update:models', {
          ...this.models,
          [this.formData.model]: val
        });
        // this.$emit('input-change', val, this.formData.model)
      }
    },
    models: {
      deep: true,
      handler(val) {
        this.dataModel = val[this.formData.model];
        if (this.formData.type === 'autoNew' && this.formData.options.otherquery && this.formData.options.otherquery.length > 0) {
          this.formData.options.otherquery.forEach(item => { // 添加或修改查询条件
            const otherIndex = this.otherQuery.findIndex(m => { // 查找有没有对应的查询条件
              return m.key === item.querykey;
            });
            if (otherIndex > -1) { // 若有，则修改
              this.otherQuery[otherIndex].value = this.models[item.modelkey] === undefined ? item.modelkey : this.models[item.modelkey];// 如果为空则为值，不是对象中的属性字段的值
              this.otherQuery[otherIndex].relation = item.relation ? item.relation : '==';// 关系符
            } else {
              this.otherQuery.push({
                key: item.querykey, // 查询的key
                relation: item.relation ? item.relation : '=', // 关系符
                value: this.models[item.modelkey] === undefined ? item.modelkey : this.models[item.modelkey]// 如果为空则为值，不是对象中的属性字段的值
              });
            }
          });
        }
      }
    }
  }
};
</script>
